<template lang="pug">
  v-container.pa-0(style="max-width: 800px;")
    v-card(tile v-if="lead" :style="isPrinting? 'min-height: 96vh; border-radius: 0' : 'min-height: 96vh;'" :class="isPrinting? 'elevation-0': ''")
      v-card-title.white(:class="isPrintingSmall ? 'px-0' : 'px-4'")
        p.mb-0.h6.basic800--text(v-if="lead.paid") Receipt &#35;{{ lead.rid }}
        p.mb-0.h6.basic800--text(v-else) Order Form &#35;{{ lead.rid }}
        v-spacer
        v-chip.text-uppercase.my-auto.button-AA-tiny(v-if="!isPrintingSmall" small outlined label :color="lead.status | leadStatusColor" :style="{ 'background-color': chipBackgroundColor(lead.status) + '!important' }" )
          | {{ lead.status | leadStatusDisplay }}

      v-layout.my-6(v-if="isFetching")
        v-row.fill-height.ma-0(align='center' justify='center')
          v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
      v-card-text.text-center(v-else :class="isPrintingSmall ? 'py-4 px-0' : 'pa-4'")
        v-form(ref="form")
          div
            v-icon(v-if="$route.query.error && !lead.paid" color="red" :size="30" x-large) mdi-close-circle
            eva-icon(v-else name="checkmark-circle-2-outline" :fill="lead.paid ? $vuetify.theme.themes[$theme].success500 : $vuetify.theme.themes[$theme].basic600T48" height="60" width="60")
            p.s1.mb-0.mt-5(:class="lead.paid ? 'primary500--text' : 'danger500--text'") {{ lead.paid ? 'Amount paid' : 'Balance due' }}
            template(v-if="lead.paid")
              div.h4.primary500--text.text-center {{ totalPaid | displayPrice($currency) }}
              div.p2.primary400--text.mt-1 {{ lead.paid_at | convertServerDate }}
              //- v-btn.button-Aa-small.custom-transform-class.text-none.mt-2(v-if="!isPrinting && hasTrackingCode" color="textColorAccent" text  @click="showParcelHistoryDialog = true" small)
                v-icon.mr-2.c1(color="textColorAccent" small) mdi-map-marker-radius-outline
                | track your parcel

            template(v-else)
              div.h4.primary500--text.text-center {{ amountDue | displayPrice($currency) }}
              div(v-if="$route.query.error")
                div.p2.danger500--text.mt-2 Payment failed
                v-chip.mt-2(color="textColorAccent" small label link @click="verifyPayment()" dark) Verify again
                  v-icon(right size=14) mdi-refresh
                v-chip.mt-2.ml-2(v-if="$route.query.retry" color="textColorAccent" small label link @click="reportPayment()" dark :disabled="reportBtnState == 'sending' || reportBtnState == 'done'") Report payment issue
                  v-icon(v-if="reportBtnState == 'pending'" right size=14) mdi-send
                  v-progress-circular.ma-auto.ml-2(v-if="reportBtnState == 'sending'" :width="2" :size="12" color="white" indeterminate)
                  v-icon(v-if="reportBtnState == 'done'" right size=14) mdi-check
              div.p2.primary400--text.mt-2(v-else) Please check all details before proceeding to payment

            v-divider.basic300.my-3

            template(v-if="(lead.paid || lead.cod) && !lead.pickup && !isPrinting")
              div.primary--text
                template(v-if="lead.shipping && lead.shipping.tracking_id")
                  div.c2.mb-1 {{ lead.shipping.courier }}
                  div.p1 {{ lead.shipping.tracking_id }}
                div.p1(v-else-if="lead.shipping && lead.shipping.on_demand_details") Your tracking details are ready
                div.p1(v-else) Your order is being processed
          v-divider.basic300.my-6
          .company-details.text-left.mt-4(v-if="company")
            div.d-flex
              div(style="word-break: break-word")
                div.s1.primary500--text {{ company.name }}
              v-spacer
              div
                v-chip.text-uppercase.my-auto.button-AA-tiny(v-if="!isPrinting" small outlined label color="success500" :style="{ 'background-color': $vuetify.theme.themes[$theme].successT08 + '!important'}" @click="clickAskMerchat()")
                  v-icon(left small) mdi-whatsapp
                  | WhatsApp us
            div.p2.primary500--text {{ company.phone }}
            div.p2.primary500--text(v-if="company.address")
              div {{ company.address.address_1 }},
              div(v-if="company.address.address_2") {{ company.address.address_2 }},
              template(v-if="company.address.area")
                div {{ company.address.postcode }} {{ company.address.area }},
                div {{ company.address.suburb }}, {{ company.address.city }},
              div(v-else) {{ company.address.postcode }} {{ company.address.city }},
              div {{ company.address.state }}, {{ company.address.country }}.

          .client-details.text-left.mt-8
            div.p1.primary500--text Bill to:
            div.s1.primary500--text {{ lead.name }}
            div.p2.primary500--text(v-if="lead.email") {{ lead.email }}
            div.p2.primary500--text {{ lead.phone | phoneFormat }}
            div.mt-5(v-if="lead.shipping_address && !lead.pickup")
              .ship-to-others(v-if="lead.shipping_address.phone && !lead.phone.endsWith(lead.shipping_address.phone)")
                div.p1.primary500--text Ship to:
                div.s1.primary500--text(v-if="lead.shipping_address.name") {{ lead.shipping_address.name }}
                div.p2.primary500--text(v-if="lead.shipping_address.phone") {{ lead.shipping_address.phone | phoneFormat }}
              .ship-to-self(v-else)
                div.p1.primary500--text Shipping address:
              div.p2.primary500--text {{ lead.shipping_address.address_1 }},
              div.p2.primary500--text(v-if="lead.shipping_address.address_2") {{ lead.shipping_address.address_2 }},
              template(v-if="lead.shipping_address.area")
                div.p2.primary500--text {{ lead.shipping_address.postcode }} {{ lead.shipping_address.area }},
                div.p2.primary500--text {{ lead.shipping_address.suburb }}, {{ lead.shipping_address.city }},
              div.p2.primary500--text(v-else) {{ lead.shipping_address.postcode }} {{ lead.shipping_address.city }},
              div.p2.primary500--text {{ lead.shipping_address.state }}, {{ lead.shipping_address.country }}.
            div.mt-5(v-if="lead.asking_delivery_date || lead.asking_delivery_time")
              div.p2.primary500--text(v-if="lead.asking_delivery_date") {{ lead.pickup ? 'Pickup date' : 'Delivery date' }}: {{ lead.asking_delivery_date | displayDate }}
              div.p2.primary500--text(v-if="lead.asking_delivery_time") {{ lead.pickup ? 'Pickup time' : 'Delivery time' }}: {{ lead.asking_delivery_time | displayTime }}
          
          v-divider.my-4.basic300

          v-simple-table(dense)
            thead
              tr
                th.pa-0(style="border: none")
                  div.s1.primary400--text.text-start.mr-1 Description
                th.pa-0(v-if="!isPrintingSmall" style="border: none")
                  div.s1.primary400--text.text-end.mx-1 Price
                th.pa-0(style="border: none")
                  div.s1.primary400--text.text-end.ml-1 Amount
            tbody
              template(v-for="p in invoice.products")
                tr(:key="p.id")
                  td.text-start.pa-0(style="border: none; vertical-align:top;")
                    div.my-1
                      div.p2.primary500--text.mr-1 {{ p.quantity }} x {{ getName(p) }} {{ p.addons.length > 0 ? ' set' : '' }}
                      div.c1.danger500--text(v-if="p.product.inventory_enabled && p.product.inventory_qty < p.quantity && !lead.paid && lead.status !== 'partial_payment'") {{ p.product.inventory_qty > 0 ? `Only ${p.product.inventory_qty} left in stock` : 'Sold out' }}
                      div.ml-3
                        //- VARIANT NAME
                        template(v-if="sameVariantParentName(p)")
                          div.c1.mt-1.mr-1(:class="!isPrintingSmall ? 'basic600--text' : 'primary500--text'") {{ p.product.name }}
                        //- ADDON LIST
                        template(v-if="p.addons.length > 0")
                          div.c1.mr-1.mt-1(:class="!isPrintingSmall ? 'basic600--text' : 'primary500--text'") {{ p.name }}
                          div(v-for="(a, idx) in p.addons" :key="'addon-' + idx")
                            div.c1.mr-1(:class="!isPrintingSmall ? 'basic600--text' : 'primary500--text'") + {{ a.name }}{{ a.quantity_per_set > 1 ? ' x ' + a.quantity_per_set : '' }}
                            div.c1.danger500--text(v-if="a.inventory_enabled && a.inventory_qty < a.quantity && !lead.paid && lead.status !== 'partial_payment'") {{ a.inventory_qty > 0 ? `Only ${a.inventory_qty} left in stock` : 'Sold out' }}
                        //- BUNDLE LIST
                        template(v-if="p.bundles.length > 0")
                          div.mt-1(v-for="(b, idx) in p.bundles" :key="'bundle-' + idx")
                            div.c1.mr-1(:class="!isPrintingSmall ? 'basic600--text' : 'primary500--text'") {{ idx + 1 }}. {{ b.name }}
                            //- BUNDLE PRODUCT NOTES
                            div(v-if="b.product_notes_data && b.product_notes_data.length > 0")
                              div(v-for="note in b.product_notes_data" :key="note.id")
                                div.c1.mx-1(:class="!isPrintingSmall ? 'basic600--text' : 'primary500--text'") - 
                                  strong {{ note.name }}: 
                                  | {{ note.data }}
                            div.c1.danger500--text(v-if="b.product.inventory_enabled && b.product.inventory_qty < b.quantity && !lead.paid") {{ b.product.inventory_qty > 0 ? `Only ${a.inventory_qty} left in stock` : 'Sold out' }}
                        //- PRODUCT NOTES
                        div.mt-1(v-if="p.product_notes_data && p.product_notes_data.length > 0")
                          div(v-for="note in p.product_notes_data" :key="note.id")
                            div.c1.mr-1(:class="!isPrintingSmall ? 'basic600--text' : 'primary500--text'")
                              strong {{ note.name }}: 
                              | {{ note.data }}

                  td.text-end.pa-0(v-if="!isPrintingSmall" style="border: none; min-width: 70px; vertical-align:top;")
                    div.my-1
                      div.p2.primary500--text.mx-1 {{ p.price_per_set | displayPrice($currency) }}
                      div.mt-3(v-if="p.product.inventory_enabled && p.product.inventory_qty < p.quantity && !lead.paid")
                      template(v-if="p.addons.length > 0")
                        div.c1.basic600--text.mx-1.mt-1 {{ p.price | displayPrice($currency) }}
                        template(v-for="a in p.addons")
                          div.c1.basic600--text.mx-1 {{ a.price * a.quantity_per_set | displayPrice($currency) }}
                  td.text-end.pa-0(style="border: none; min-width: 70px; vertical-align:top;")
                    div.my-1.p2.primary500--text.ml-1 {{ p.price_per_set * p.quantity | displayPrice($currency) }}

          div.my-5.dotted
          v-btn.button-Aa-small(v-if="!singlePageCheckout && isEditable" color="textColorAccent" text @click="openAddProducts()" small)
            eva-icon.mt-1.mr-2(name="edit-outline" :fill="$vuetify.theme.themes[$theme].textColorAccent" height="14" width="14")
            | Edit Order

          div
            div.d-flex.mt-1
              div.p1.primary400--text Subtotal:
              v-spacer
              div.p1.primary400--text {{ subtotalPrice | displayPrice($currency) }}
            div.d-flex.mt-1(v-if="discountPrice")
              div.p1.primary400--text Discount:
              v-spacer
              div.p1.primary400--text {{ discountPrice | displayPrice($currency) }}
            div.d-flex.mt-1(v-if="promoDiscountPrice")
              div.p1.primary400--text Promo Discount:
              v-spacer
              div.p1.primary400--text {{ promoDiscountPrice | displayPrice($currency) }}
            div.d-flex.mt-1
              div.p1.primary400--text Tax:
              v-spacer
              div.p1.primary400--text {{ taxAmount }}%
            div.d-flex.align-center.mt-1(v-if="shippingFee !== null && !lead.pickup")
              div.p1.primary400--text Delivery Charge:
              v-spacer
              div.p1.primary400--text(v-if="shippingFee === 0")
                v-chip.px-1(color="success500" small label outlined)
                  v-icon(small).pr-1 mdi-truck-fast
                  | Free Shipping
              div.p1.primary400--text(v-else) {{ shippingFee | displayPrice($currency) }}
            div.d-flex.mt-1(v-if="serviceFee")
              div.p1.primary400--text Service Fee:
              v-spacer
              div.p1.primary400--text {{ serviceFee | displayPrice($currency) }}
            div.d-flex.mt-1
              div.h6.primary--text Total:
              v-spacer
              div.h6.primary--text {{ totalPrice | displayPrice($currency) }}
            div.d-flex.mt-1
              div.p1.primary400--text Amount Paid:
              v-spacer
              div.p1.primary400--text {{ totalPaid | displayPrice($currency) }}

            .installment(v-if="lead.installment && !lead.paid")
              div.d-flex.py-2.ml-n2.mr-n2.mt-1(:style="`background-color: ${$vuetify.theme.themes[$theme].dangerT16}; border-radius: 4px`")
                div.s1.primary--text.ml-2 Balance Due:
                v-spacer
                div.s1.primary--text.mr-2 {{ amountDue | displayPrice($currency) }}
              div.d-flex.mt-2
                div.c1.primary400--text Please complete payment before: {{ invoice.installment_deadline | humanizeDate}}

            template(v-if="!singlePageCheckout")
              div.d-flex.mt-2(v-if="isEditable || invoice.coupons.length > 0")
                div.p1.primary400--text Coupon code:
                v-spacer
                div
                  template(v-if="invoice.coupons.length > 0")
                    div.d-flex(@click="isEditable? showApplyCouponDialog = true : ''")
                      v-spacer
                      div.body-2.text-right.success500--text {{ invoice.coupons[0].code }}
                      template(v-if="isEditable" style="cursor:pointer")
                        v-icon.ml-1(small color="danger500") mdi-delete-outline
                    div.c1.text-right.danger500--text(v-if="!invoice.coupons[0].valid") {{ getCouponErrorMessage(invoice.coupons[0].validity_error) }}
                  div.body-2.my-auto.text-right.info500--text(v-else style="width:120px; cursor:pointer" @click="showApplyCouponDialog = true") Select Coupon

            template(v-if="lead.cod")
              div.d-flex.mt-1
                div.p1.primary400--text Payment type:
                v-spacer
                div.p1.primary400--text Cash on delivery
            template(v-if="lead.pay_at_shop")
              div.d-flex.mt-1
                div.p1.primary400--text Payment type:
                v-spacer
                div.p1.primary400--text Pay at shop

          div.pt-6(align="center" v-if="lead.pickup && lead.status !== 'received'")
            v-card.pa-4(outlined max-width="500px" :style="`border: 2px solid ${$vuetify.theme.themes[$theme].primary300} !important;`")
              div.s1.success500--text.d-flex.justify-center.align-center
                eva-icon.mr-1.mt-1(name="pin-outline" width="16px" height="16px" :fill="$vuetify.theme.themes[$theme].success500")
                div Self-pickup
              div.mt-2.p2.primary400--text(style="word-break: break-word;")
                template(v-if="lead.shipping")
                  linkify-text.body-2(v-if="(typeof lead.shipping.tracking.pickup_address) === 'object'" :text="getStringFromAddress(lead.shipping.tracking.pickup_address)")
                  linkify-text.body-2(v-else :text="lead.shipping.tracking.pickup_address")

          template(v-if="!singlePageCheckout && isEditable && zones.length > 0")
            v-btn.button-AA-small.mt-6.white--text(v-if="!lead.shipping" color="success500" height="32" @click="openDeliveryOption" depressed)
              eva-icon.mt-1.mr-2(name="car-outline" fill="white" height="14" width="14")
              | Choose Delivery
            v-btn.button-Aa-small.mt-6(v-else color="textColorAccent" text @click="openDeliveryOption" small)
              eva-icon.mt-1.mr-2(name="edit-outline" :fill="$vuetify.theme.themes[$theme].textColorAccent" height="14" width="14")
              | Edit Delivery

          div.mx-n4.neutral300.mt-6(v-if="company.logo && company.logo.file")
            v-row(no-gutters justify="center")
              v-col.pa-4(cols="12" align="center")
                v-img(:src="company.logo.file" eager class="company-logo")
                div.text-lg.font-medium.neutral900--text.mt-1 {{ company.name }}

          div.mt-6
            div.f1.primary400--text {{ $t('powered_by_yezza') }}
            div.f2.primary400--text(v-if="lead.paid") This is a computer generated receipt. No signature required.
            div.f2.primary400--text(v-else) This is a computer generated invoice. No signature required.

          div.pt-6(v-if="!lead.paid && !lead.cod && !lead.pay_at_shop && lead.status != 'reject'")
            v-btn.button-AA-medium.white--text(v-if="hasPaymentMethod" color="textColorAccent" depressed block @click="clickPay" :disabled="outOfStock && !singlePageCheckout") {{ singlePageCheckout ? 'Checkout' : 'Pay now' }}
            div.caption.danger500--text.mt-2(v-if="outOfStock") Not enough stock available. Change your order quantity or consult with seller.

    v-footer(v-if="lead.paid && !isPrinting" fixed app)
      v-container.pa-0(style="max-width:770px")
        v-btn.my-2.accent.button-AA-medium(block :loading="isLoading" @click="startCopyOrder") repeat order

    .modals
      parcel-history-dialog(v-if="showParcelHistoryDialog" :open.sync="showParcelHistoryDialog" :lead="lead" :shipping="lead.shipping")
      apply-coupon-dialog(v-if="showApplyCouponDialog" :open.sync="showApplyCouponDialog" :invoice="invoice" @applied="getInvoice")

      y-dialog(v-if="showSetAmountDialog" v-model='showSetAmountDialog', max-width='320')
        v-card
          v-card-title.h6.basic800--text Set Amount
          v-divider.basic300
          v-card-text.pa-4
            v-form(ref="form")
              p.mb-1.label.basic600--text.text-uppercase {{ $t('price.label') }}
              v-text-field.mt-2(v-model='paymentAmount' :placeholder="$t('price.placeholder')" background-color="basic200" height="40" outlined dense type="number" :rules="priceRules" :prefix="$currency.symbol")
            v-btn.button-AA-medium.white--text(block color='textColorAccent' depressed height=32 @click='clickPayPartialAmount()' :loading="isLoading")
              | Pay this amount
            div.text-center.mt-1.p2 or
            v-btn.button-Aa-medium(block color='textColorAccent' depressed height=32 @click='clickPayFullAmount()' :loading="isLoading" text)
              div(v-if="lead.status == 'partial_payment'") Pay remaining amount
              div(v-else) Pay full amount

</template>

<script>
import ParcelHistoryDialog from '@/views/invoice/components/ParcelHistoryDialog'
import ApplyCouponDialog from '@/views/invoice/components/ApplyCouponDialog'
import LinkifyText from '@/components/LinkifyText.vue'
import { mapActions } from 'vuex'
import axios from 'axios'
export default {
  name: 'CustomerInvoice',
  components: { ParcelHistoryDialog, ApplyCouponDialog, LinkifyText },
  props: ['lead'],
  data: () => ({
    isFetching: true,
    invoice: null,
    company: null,
    bankList: [],
    zones: [],
    showParcelHistoryDialog: false,
    showSetAmountDialog: false,
    showApplyCouponDialog: false,
    paymentAmount: null,
    isLoading: false,
    singlePageCheckout: false,
    reportBtnState: 'pending',
    rules: {
      not_empty: [
        val => val != null || 'This field is required',
        val => val > 0 || 'This field is required'
      ]
    }
  }),
  computed: {
    isPrinting () {
      if (this.$route.path.includes('print-invoices') || this.$route.path.includes('print-invoices-small')) {
        return true
      }
      return false
    },
    isPrintingSmall () {
      if (this.$route.path.includes('print-invoices-small')) {
        return true
      }
      return false
    },
    isEditable () {
      if (this.lead.paid) {
        return false
      }
      if (this.lead.cod) {
        return false
      }
      if (this.lead.pay_at_shop) {
        return false
      }
      if (this.lead.installment && this.lead.status == 'partial_payment') {
        return false
      }
      if (this.lead.status === 'reject') {
        return false
      }
      return true
    },
    priceRules () {
      return [
        v => !!v || 'Amount is required',
        v => v != 0|| 'Amount is required',
        v => v >= this.minPaymentAmount/this.$currency.multiplier || `Amount should not be below ${this.$currency.symbol} ${(parseFloat(this.minPaymentAmount/this.$currency.multiplier)).toFixed(this.$currency.exponent)}`,
        v => v <= this.amountDue/this.$currency.multiplier || `Amount should not be above ${this.$currency.symbol} ${(parseFloat(this.amountDue/this.$currency.multiplier)).toFixed(this.$currency.exponent)}`,
      ]
    },
    outOfStock() {
      if (this.lead.status === 'partial_payment') return false
      if (!this.invoice) return false
      for (let i = 0; i < this.invoice.products.length; i++) {
        let p = this.invoice.products[i]
        if (p.product.inventory_enabled && p.product.inventory_qty < p.quantity) {
          return true
        }
      }
      return false
    },
    shippingFee() {
      if (!this.invoice) return 0
      return this.invoice.shipping_fee
    },
    discountPrice() {
      if (!this.invoice) return 0
      return this.invoice.total_discount
    },
    promoDiscountPrice() {
      if (!this.invoice) return 0
      return this.invoice.total_promo_discount
    },
    subtotalPrice() {
      if (!this.invoice) return 0
      return this.invoice.subtotal_amount
    },
    serviceFee() {
      if (!this.invoice) return 0
      return this.invoice.service_fee
    },
    totalPrice() {
      if (!this.invoice) return 0
      return this.invoice.total_amount
    },
    totalPaid() {
      if (!this.invoice) return 0
      return this.invoice.total_paid
    },
    amountDue() {
      if (!this.invoice) return 0
      return this.invoice.total_amount - this.invoice.total_paid
    },
    taxAmount() {
      if (!this.invoice) return 0
      return this.invoice.company.tax_rate
    },
    minPaymentAmount() {
      if (!this.invoice.minimum_payment) return 0
      if (this.invoice.minimum_payment > this.amountDue) {
        return this.amountDue
      }
      return this.invoice.minimum_payment
    },
    hasPaymentMethod () {
      if (this.company && this.company.default_payment_gateway) return true
      if (this.bankList.length > 0) return true
      if (this.lead.allow_cod) {
        return true
      }
      if (this.lead.allow_pay_at_shop) {
        return true
      }
      return false
    },
    hasTrackingCode () {
      if (this.lead.shipping && (this.lead.shipping.tracking_id || this.lead.shipping.shipping_method === 'easyparcel')) {
        return true
      }
      return false
    }
  },
  mounted () {
    this.fetchCompanyGenes()
    this.fetchRequiredInfo()
    if (!this.lead.paid) {
      this.fetchBankAccount()
    }
    this.company = this.lead.form.company
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    getStringFromAddress (address) {
      return `${address.address_1},${address.address_2 ? ` ${address.address_2},` : ''} ${address.postcode},${address.area ? ` ${address.area}, ${address.suburb},` : ''} ${address.city}, ${address.state}, ${address.country}`
    },
    getCouponErrorMessage (error) {
      if (this.$t(`coupon_error.${error.state}`).includes('coupon_error') ) {
        return this.$t('coupon_error.default')
      } else if (error.state === 'invoice_datetime') {
        let condition = 'is not ready yet'
        if (error.operator === 'lte') {
          condition = 'is expired'
        }
        return this.$t('coupon_error.invoice_datetime', { condition: condition})
      } else if (error.state === 'subtotal_no_tax') {
        return this.$t('coupon_error.subtotal_no_tax', { min_order: this.$options.filters.displayPrice(error.condition, this.$currency)})
      }
      return this.$t('coupon_error.default')
    },
    getInvoice () {
      this.isFetching = true
      this.$axios.get(`/invoices/${this.lead.pid}/`)
        .then((response) => {
          this.isFetching = false
          this.invoice = response.data
        })
        .catch(() => {})
    },
    fetchBankAccount () {
      this.$axios.get(`/leads/${this.lead.pid}/directpay/`)
        .then((response) => {
          response.data.results.forEach(bank => {
            if (bank.enabled) {
              this.bankList.push(bank)
            }
          })
        })
        .catch(() => {})
    },
    fetchRequiredInfo () {
      this.isFetching = true
      this.$axios.get(`/forms/${this.lead.form.slug}/zones`)
        .then((response) => {
          this.zones = response.data
        })
        .catch(() => {})
        .finally(() => {
          this.getInvoice()
        })
    },
    fetchCompanyGenes () {
      this.$axios.get(`/companies/${this.lead.company}/genes`)
        .then((response) => {
          if (response.data.filter(f => f.feature === 'YZ_CHECKOUT_V2').length > 0) {
            this.singlePageCheckout = true
          }
        })
        .catch(() => {})
    },
    getName (product) {
      if (product.product.variant_for) {
        if (this.sameVariantParentName(product)) {
          return product.name.replace(`(${product.product.name})`, '')
        }
      }
      return product.name
    },
    sameVariantParentName (product) {
      return product.name.includes(`(${product.product.name})`)
    },
    clickPay() {
      if (this.singlePageCheckout) {
        location.href = `https://checkout.${process.env.VUE_APP_BASE_DOMAIN}/checkout/${this.lead.pid}`
        return
      }
      if (!this.lead.shipping && this.zones.length > 0) {
        this.showMessage(['error', `Choose delivery to proceed for this order`])
        this.openDeliveryOption()
        return
      }
      if (this.lead.installment) {
        this.showSetAmountDialog = true
      } else {
        location.href = `/invoices/${this.lead.pid}/pay`
      }
    },
    clickPayPartialAmount() {
      if (!this.$refs.form.validate()) {
        return
      }
      const amountInCent = (parseFloat(this.paymentAmount)).toFixed(this.$currency.exponent).replace('.', '')
      location.href = `/invoices/${this.lead.pid}/pay?amount=${amountInCent}`
    },
    clickPayFullAmount() {
      location.href = `/invoices/${this.lead.pid}/pay`
    },
    openDeliveryOption (){
      location.href = `/invoices/${this.lead.pid}/delivery`
    },
    openAddProducts () {
      location.href = `/invoices/${this.lead.pid}/catalogs`
    },
    startCopyOrder () {
      if (this.lead.member && this.lead.member.role === 'Agent') {
        this.$axios.get(`/forms/${this.lead.form.slug}?agent_member_id=${this.lead.member.id}`)
        .then((response) => {
          location.href = `https://${process.env.VUE_APP_SHORT_URL_DOMAIN}/${response.data.slug}/?customer=${this.lead.pid}`
        })
        .catch(() => {})
        return
      }
      if (this.lead.form.type === 'store') {
        location.href = `https://${this.lead.form.company.slug}.${process.env.VUE_APP_STORE_URL_DOMAIN}/?customer=${this.lead.pid}`
        return
      }
      location.href = `https://${process.env.VUE_APP_SHORT_URL_DOMAIN}/${this.lead.form.slug}/?customer=${this.lead.pid}`
    },
    verifyPayment() {
      this.$axios.post(`/leads/${this.lead.pid}/recheck_payments/`)
      .then(() => {
        if (this.lead.hostname) {
          location.href = `https://${this.lead.hostname}/invoices/${this.lead.pid}/verify?retry=true`
          return
        }
        location.href = `/invoices/${this.lead.pid}/verify?retry=true`
      })
    },
    reportPayment() {
      this.reportBtnState = 'sending'
      const params = new URLSearchParams()
      params.append('invoice', `https://${this.lead.hostname}/invoices/${this.lead.pid}` )
      params.append('lead_id', this.lead.id)
      params.append('company_id', this.lead.form.company.id)
      axios.post('https://hooks.zapier.com/hooks/catch/1847976/b3jbg4w/', params, { headers: {'Content-Type': 'application/x-www-form-urlencoded' } })
      .then(() => {
        this.showMessage(['success', this.$t('success_message.your_concern_reported')])
        this.reportBtnState = 'done'
      })
    },
    clickAskMerchat () {
      window.open(`https://api.whatsapp.com/send?phone=${this.lead.member.phone}`, '_blank')
    },
    chipBackgroundColor (status) {
      if (status === 'new') {
        return this.$vuetify.theme.themes[this.$theme].infoT08
      } else if (status === 'follow_up') {
        return this.$vuetify.theme.themes[this.$theme].warningT08
      } else if (status === 'partial_payment') {
        return this.$vuetify.theme.themes[this.$theme].basic600T08
      } else if (status === 'reject') {
        return this.$vuetify.theme.themes[this.$theme].dangerT08
      } else if (status === 'processed') {
        return this.$vuetify.theme.themes[this.$theme].successT08
      } else if (status === 'shipped') {
        return this.$vuetify.theme.themes[this.$theme].warningT08
      } else if (status === 'received') {
        return this.$vuetify.theme.themes[this.$theme].basic600T08
      } else if (status === 'cancelled') {
        return this.$vuetify.theme.themes[this.$theme].dangerT08
      } else if (status === 'error') {
        return this.$vuetify.theme.themes[this.$theme].dangerT08
      } else if (status === '') {
        return this.$vuetify.theme.themes[this.$theme].basic600T08
      }
      return this.$vuetify.theme.themes[this.$theme].basic600T08
    }
  }
}
</script>

<style scoped>
.dotted {
  border-top: 2px dashed var(--v-primary400);
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
.company-logo {
  width: 30%;
}
</style>

<i18n>
  {
    "en": {
      "price": {
        "label": "Amount",
        "placeholder": "0"
      },
      "coupon_error": {
        "default": "*Invalid coupon code",
        "invoice_datetime": "*This coupon {condition}",
        "subtotal_no_tax": "*Min order: {min_order}"
      }
    },
    "en": {
      "price": {
        "label": "Jumlah",
        "placeholder": "0"
      },
      "coupon_error": {
        "default": "*Kode Kupon tidak valid",
        "invoice_datetime": "*Kupon ini {condition}",
        "subtotal_no_tax": "*Min order: {min_order}"
      }
    }
  }
</i18n>
